import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './auth/login/login.component';
import { ComponentsModule } from './components/components.module';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { HttpRequestService } from './core/http-request/http-request.service';
import { AuthService } from './core/services/auth/auth.service';
import { AuthGuardService } from './core/services/auth-guard/auth-guard.service';
import { RedirectService } from './core/services/auth-guard/redirect.service';
import { RequestServiceService } from './core/services/request-service/request-service.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CookieService } from 'ng2-cookies';
import { MessagesService } from './core/services/messages/messages.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RegisterComponent } from './auth/register/register.component';
import { OtpComponent } from './auth/otp/otp.component';
import { NgOtpInputModule } from  'ng-otp-input';
import { UpdateBookingStatusComponent } from './update-booking-status/update-booking-status.component';
import { SessionExpiredComponent } from './core/session-expired/session-expired.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { initializeApp,provideFirebaseApp } from '@angular/fire/app';
import { MessagingModule } from '@angular/fire/messaging';



import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { GoogleMapsService } from './google-maps.service';
import { ImagePreviewDialogComponent } from './dialogs/image-preview-dialog/image-preview-dialog.component';
import {MatDividerModule} from '@angular/material/divider';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SocialLoginModule, SocialAuthServiceConfig } from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';
import { environment } from 'src/environments/environment';
import { WebviewComponent } from './webview/webview.component';

import { MatDialogModule } from '@angular/material/dialog';

import { DiscardChangesService } from './core/services/discard-changes.service';
import { DiscardChangesGuard } from './discard-changes.guard.service';
import { ToastrModule } from 'ngx-toastr';
import { NotificationDialogComponent } from './notification-dialog/notification-dialog.component';
import { ConfirmationPopupComponent } from './confirmation-popup/confirmation-popup.component';
import { AddDiscountPercentageComponent } from './add-discount-percentage/add-discount-percentage.component';

//import { AgmCoreModule } from '@hudsontavares/agm-core';
const googleOAuthClientId = '949545769449-2crql0mqd0geu3mjf9qot9lgd0e96cma.apps.googleusercontent.com';
const config: SocialAuthServiceConfig = {
  providers: [
    {
      id: GoogleLoginProvider.PROVIDER_ID,
      provider: new GoogleLoginProvider(googleOAuthClientId)
    },
    // Add other providers if needed
  ]
};
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SessionExpiredComponent,
    RegisterComponent,
    AdminLayoutComponent,
    OtpComponent,
    UpdateBookingStatusComponent,
    ImagePreviewDialogComponent,
    VerifyEmailComponent,
    ForgotPasswordComponent,
    WebviewComponent,
    NotificationDialogComponent,
    ConfirmationPopupComponent,
    
  ],
  imports: [
    SocialLoginModule,
    NgOtpInputModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    NgxMatSelectSearchModule,
    BrowserModule,
    MatSnackBarModule,
    RouterModule,
    ComponentsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyBKr5T6RqjrHZfhizgPKlsFh-Yz8KYTvVI',
    //   libraries: ['places']
    // }),
    MatDialogModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatDividerModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    
    MessagingModule,
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
  ],
  providers: [
    {
      provide: "SocialAuthServiceConfig",
      useValue: {
        autoLogin: true,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.gmailSocialLoginKey, {
              scope: environment.scope,
              plugin_name: environment.pluginName,
            }),
          },
        ],
      } as SocialAuthServiceConfig,
    },
    CookieService,
    HttpRequestService,
    AuthService,
    AuthGuardService,
    RedirectService,
    RequestServiceService,
    MessagesService,
    GoogleMapsService,DiscardChangesService,DiscardChangesGuard
],
  bootstrap: [AppComponent]
})
export class AppModule { }
